import * as z from 'zod/mini';

import { PAYMENT_METHOD_CODES, WALLET_ACCOUNT_TYPES } from '@/constants/deposit';

/**
 * `.strict()` so a stray `gateway` / `method` fails in our tests, not as a 422 in production.
 * Length and format of `payerWalletNumber` are the selected rail's `inputFields`, not this schema.
 */
export const cashierChooseBodySchema = z.union([
  z.strictObject({
    path: z.literal('api'),
    gatewayAccountId: z.string(),
    payerWalletNumber: z.string().check(z.trim(), z.minLength(1), z.regex(/^\d+$/)),
    paymentMethodCode: z.enum(PAYMENT_METHOD_CODES),
  }),
  z.strictObject({
    path: z.literal('wallet'),
    accountType: z.enum(WALLET_ACCOUNT_TYPES),
    traderWalletId: z.string().check(z.minLength(1)),
  }),
]);

export type CashierChooseBody = z.infer<typeof cashierChooseBodySchema>;
